
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/references",
      function () {
        return require("private-next-pages/references/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/references"])
      });
    }
  